'use strict';
import {Observable} from 'rxjs/Observable';
import {Subscriber} from 'rxjs/Subscriber';

/**
 * @typedef {Object} PositionEvent
 * @property {String} code
 * @property {Boolean} isError
 * @property {?Position} position
 * @property {?PositionError} error
 */

/**
 * @typedef {Observable<PositionEvent>} WatchPositionObservable
 */

export class WatchPositionObservable extends Observable {
  constructor(options) {
    super();

    this.options = options;
  }

  /**
   * @param {Subscriber} subscriber
   * @protected
   * @override
   */
  _subscribe(subscriber) {
    return new WatchPositionSubscriber(subscriber, this.options);
  }
}

/**
 * @typedef {Subscriber<PositionEvent>} WatchPositionSubscriber
 */

export class WatchPositionSubscriber extends Subscriber {

  constructor(destination/*: Subscriber<T>*/, options) {
    super(destination);

    this.id = global.window.navigator.geolocation.watchPosition(
      data => this.next(data),
      e => this.error(e),
      options
    );
  }

  /**
   * @param {?Position} p
   * @param {?PositionError} e
   */
  static wrapPosition(p, e) {
    if (p) {
      return {
        isError: false,
        code: 'OK',
        position: p,
        error: null,
      };
    } else if (e) {
      return {
        isError: true,
        code: WatchPositionSubscriber.getCode(e),
        position: null,
        error: e,
      };
    }
  }

  /**
   * @param {PositionError} e
   */
  static getCode(e) {
    switch(e.code) {
      case e.POSITION_UNAVAILABLE:
        return 'PU';
      case e.TIMEOUT:
        return 'TO';
      case e.PERMISSION_DENIED:
        return 'PD';
      case e.UNKNOWN_ERROR:
      default:
        return 'UE';
    }
  }

  /**
   * @param {Position} p
   */
  next(p) {
    this.destination.next(WatchPositionSubscriber.wrapPosition(p, null));
  }

  /**
   * Keep the subscription for position unavailable and timeout errors.
   * @param {PositionError} e
   */
  error(e) {
    switch(e.code) {
      case e.POSITION_UNAVAILABLE:
      case e.TIMEOUT:
        this.destination.next(WatchPositionSubscriber.wrapPosition(null, e));
        break;
      // Browsers usually require being refreshed here
      case e.PERMISSION_DENIED:
      // Do not continue when unexpected errors are received.
      // This value was pulled from w3schools and does not seem to be in the spec.
      case e.UNKNOWN_ERROR:
      default:
        super.error(WatchPositionSubscriber.wrapPosition(null, e));
    }
  }

  unsubscribe() {
    global.window.navigator.geolocation.clearWatch(this.id);
    super.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/js/_libs/rx-dom/WatchPositionObservable.js